export function roundDollars(n: number, nearest: number) {
  if (nearest <= 0) {
    throw new Error('nearest must be a positive number')
  }

  return Math.round(n / nearest) * nearest
}
